import { render, staticRenderFns } from "./dingdingList.vue?vue&type=template&id=f9dc44fc&scoped=true"
import script from "./dingdingList.vue?vue&type=script&lang=js"
export * from "./dingdingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dc44fc",
  null
  
)

export default component.exports